/**
 * схема для настроек таблицы клиентов
 * @property {array} settingsItems - элементы настроек
 */
let schemeSettingsClients = {
    columnSettings: {
        name: {
            type: 'input'
        },
        contract_type: {
            type: 'dropDown',
            isManyItems: false,
            title: ''
        },
        created_at: {
            type: 'text'
        },
    },
    labels: {
        name: 'Название клиента',
        contract_type: 'Тип договора',
        created_at: 'Дата создания'
    }
}

export default schemeSettingsClients;